import React, { useState } from "react";
import { Box, Dialog, Typography, Button } from "@mui/material";

const PageCompose = ({ open, handleClose, connect }) => {
  const [snack, setSnack] = useState({
    isOpen: false,
    msg: "",
    type: "success",
  });

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert("Амжилттай хуулагдлаа")
        setSnack({
          isOpen: true,
          msg: "Copied to clipboard!",
          type: "success",
        });
      })
      .catch(() => {
        setSnack({
          isOpen: true,
          msg: "Failed to copy!",
          type: "error",
        });
      });
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      classes={{
        paper: "min-w-[90%] sm:min-w-[400px] md:min-w-[500px] lg:min-w-[600px] p-6 sm:p-8 rounded-lg flex flex-col text-sm sm:text-base",
      }}
    >
      <Typography className="font-bold text-lg sm:text-xl text-black text-center">
        Хаяг холбох
      </Typography>

      <Box className="mt-2 mb-5 text-center">
        <Typography className="text-gray-500">
          Хаягаа холбоод чатаар заавал шалгуулаарай
        </Typography>
      </Box>

      <Box>
        {connect?.map((item, index) => (
          <Box key={index} className="mt-5">
            <Typography className="text-black font-bold text-lg">{item.branch}</Typography>

            {/* Receiver Name */}
            <Box className="flex flex-wrap border-b border-gray-400 pb-2 items-center">
              <Typography>1. 收件人 (Хүлээн авагч):</Typography>
              <Box className="ml-auto flex items-center">
                <Box className="mr-4">{item.name}</Box>
                <Box
                  onClick={() => handleCopy(item.name)}
                  className="h-8 w-16 flex justify-center rounded-md items-center text-white bg-green-500 cursor-pointer"
                >
                  Хуулах
                </Box>
              </Box>
            </Box>

            {/* Phone Number */}
            <Box className="mt-5 flex flex-wrap border-b border-gray-400 pb-2">
              <Typography>2. 电话 (Утасны дугаар):</Typography>
              <Box className="ml-auto flex items-center">
                <Box className="mr-4">{item.phone}</Box>
                <Box
                  onClick={() => handleCopy(item.phone)}
                  className="h-8 w-16 flex justify-center rounded-md items-center text-white bg-green-500 cursor-pointer"
                >
                  Хуулах
                </Box>
              </Box>
            </Box>

            {/* Region */}
            <Box className="mt-5 flex flex-wrap border-b border-gray-400 pb-2">
              <Typography>3. 所在地区 (Бүс нутаг):</Typography>
              <Box className="ml-auto flex items-center">
                <Box className="mr-4">{item.price}</Box>
                <Box
                  onClick={() => handleCopy(item.price)}
                  className="h-8 w-16 flex justify-center rounded-md items-center text-white bg-green-500 cursor-pointer"
                >
                  Хуулах
                </Box>
              </Box>
            </Box>

            {/* Address */}
            <Box className="mt-5 flex flex-wrap">
              <Typography>4. (Хаяг)</Typography>
              <Box className="ml-auto flex items-center">
                <Box className="mr-4">{item.location}</Box>
                <Box
                  onClick={() => handleCopy(item.location)}
                  className="h-8 w-16 flex justify-center rounded-md items-center text-white bg-green-500 cursor-pointer"
                >
                  Хуулах
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Close Button */}
      <Box className="mt-10 sm:mt-14 mx-auto">
        <Button
          className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-500"
          onClick={handleClose}
        >
          Цонхыг хаах
        </Button>
      </Box>
    </Dialog>
  );
};

export default PageCompose;
